import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ProductSelector } from "../rawData/product/productSelector";
import { WarehouseMultiSelectorViewModel } from "../rawData/warehouse/warehouseSelector";
import  { ProductCardexView } from "./productCardex-view"

export class ProductCardexViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'کاردکس کالا';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.dateTo = moment.utc();
        this.productTransactions = ObservableArray.create<ProductTransaction>();
        this.showingItems = ObservableArray.create<ProductTransaction>();
        this.warehouseSelector = new WarehouseMultiSelectorViewModel(this);
        this.productSelector = new ProductSelector(this);
        this.productSelector.onSelectionChanged = q=>{
            this.measuredProductId = q.measuredProducts[0].id;
            this.productUnit = q.measuredProducts[0].unitName;
            this.productCode = q.code;
            this.productName = q.name;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductCardexView();
    }
    public getTypeId(): string {
        return "VM-AF719A7D-EE4D-4A37-BEDF-ED2592393763"
    }
    public set warehouseSelector(v: WarehouseMultiSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseMultiSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseMultiSelectorViewModel;
    public set productSelector(v: ProductSelector) { this._productSelector = v; } public get productSelector(): ProductSelector { return this._productSelector;} private _productSelector: ProductSelector;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation;} private _warehouseLocation: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set dateFrom(v: moment.Moment) { 
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._dateFrom = v2; } public get dateFrom(): moment.Moment { return this._dateFrom;} private _dateFrom: moment.Moment;
    public set dateTo(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._dateTo = v2; 
    } public get dateTo(): moment.Moment { return this._dateTo;} private _dateTo: moment.Moment;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set productTransactions(v: ObservableArray<ProductTransaction>) { this._productTransactions = v; } public get productTransactions(): ObservableArray<ProductTransaction> { return this._productTransactions;} private _productTransactions: ObservableArray<ProductTransaction>;
    public set showingItems(v: ObservableArray<ProductTransaction>) { this._showingItems = v; } public get showingItems(): ObservableArray<ProductTransaction> { return this._showingItems;} private _showingItems: ObservableArray<ProductTransaction>;
    
    public set showAll(v: boolean) { 
        this._showAll = v;
        if(v){
            this.onlyMain = false;
            this.onlyReserving = false;
            this.updateShowingItems();
        }
    } public get showAll(): boolean { return this._showAll;} private _showAll: boolean;
    public set onlyMain(v: boolean) { 
        this._onlyMain = v; 
        if(v){
            this.showAll = false;
            this.onlyReserving = false;
            this.updateShowingItems();
        }
    } public get onlyMain(): boolean { return this._onlyMain;} private _onlyMain: boolean;
    public set onlyReserving(v: boolean) { 
        this._onlyReserving = v; 
        if(v){
            this.showAll = false;
            this.onlyMain = false;
            this.updateShowingItems();
        }
    } public get onlyReserving(): boolean { return this._onlyReserving;} private _onlyReserving: boolean;

    verify():string[]{
        let result :string[] =[];
        if(this.warehouseSelector.selectedItems.length == 0){
            result.push('انباری انتخاب نشده است.')
        }
        if(stringIsNullOrEmpty(this.measuredProductId)){
            result.push('کالایی انتخاب نشده است.')
        }
        // if(this.dateFrom == undefined){
        //     result.push('شروع بازه تاریخ انتخاب نشده شده است.')
        // }
        return result;
    }

    async getCardex() {
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان نمایش کاردکس');
                return;
            }
            this.isLoading = true;
            this.onlyMain = true;
            let result =await ServerConnection.callServer('Complex/InventoryServices/GetProductCardex',{
                ProductId:this.measuredProductId,
                From:this.dateFrom == undefined ? null : this.dateFrom,
                To:this.dateTo,
                Inventories:this.warehouseSelector.selectedItems.map(x=>x.id),
                MeasuredProductId:this.measuredProductId
            });
            this.productTransactions.update(...result.InitialAmounts.map(x=>{
                let r = new ProductTransaction(this);
                r.billNo = '';
                r.billType = 0;
                r.partyName = '';
                r.warehouseName = x.WarehouseName;
                this.warehouseLocation = result.WarehouseLocation;
                r.amount = null;
                r.warehouseBalance = x.Amount;
                r.warehouseAvailableBalance = x.AvailableAmount;
                r.cumulativeBalance = x.CumulativeWarehousesAmount;
                r.cumulatieAvailableBalance = x.CumulativeWarehousesAvailableAmount;
                r.partyName = '';
                r.billUsageParameter = '';
                r.billUsageName = '';
                r.user = '';
                r.description = '';
                return r;
            }));
            this.productTransactions.push(...result.ProductTransactions.map(x=>{
                let r = new ProductTransaction(this);
                r.billNo = x.BillNumber;
                r.date = moment.utc(x.Time);
                r.billType = x.BillType;
                r.partyName = x.PartyName;
                r.warehouseName = x.WarehouseName;
                r.amount = x.Amount;
                r.warehouseBalance = x.WarehouseAmount;
                r.warehouseAvailableBalance = x.WarehouseAvailableAmount;
                r.cumulativeBalance = x.CumulativeWarehousesAmount;
                r.cumulatieAvailableBalance = x.CumulativeWarehousesAvailableAmount;
                r.partyName = x.PartyName;
                r.billUsageParameter = x.BillUsage;
                // r.eucalyptusColor = x.BillUsageType == 1 ? true : false;
                r.billUsageName = x.BillUsageName;
                r.allBillUsages.update(...x.AllBillUsages.map(q => { 
                    let b = new BillUsage(this);
                    b.name = q;
                    return b;
                }));
                r.user = x.BillUsageUser ?? '';
                r.description = x.Description;
                return r;
            }));
            this.productTransactions.push(...result.FinalAmounts.map(x=>{
                let r = new ProductTransaction(this);
                r.billNo = '';
                r.billType = 5;
                r.partyName = '';
                r.warehouseName = x.WarehouseName;
                r.amount = null;
                r.warehouseBalance = x.Amount;
                r.warehouseAvailableBalance = x.AvailableAmount;
                r.cumulativeBalance = x.CumulativeWarehousesAmount;
                r.cumulatieAvailableBalance = x.CumulativeWarehousesAvailableAmount;
                r.partyName = '';
                r.billUsageParameter = '';
                r.billUsageName = '';
                r.user = '';
                r.description = '';
                return r;
            }))
            this.updateShowingItems();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    updateShowingItems(){
        if(this.showAll){
            this.showingItems.update(...this.productTransactions.map((x,i)=>{
                x.rowNumber = i+1;
                return x;
            }));
        }else if(this.onlyMain){
            this.showingItems.update(...this.productTransactions.filter(x=>x.isMain==true).map((x,i)=>{
                x.rowNumber = i+1;
                return x;
            }));
        }else{
            this.showingItems.update(...this.productTransactions.filter(x=>x.isReserving==true).map((x,i)=>{
                x.rowNumber = i+1;
                return x;
            }));
        }
    }
}

export class ProductTransaction extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProductCardexViewModel) {
        super(parent);
        this.allBillUsages = ObservableArray.create<BillUsage>();
        this.typedParent = parent;
    }
    private typedParent : ProductCardexViewModel;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set isMain(v: boolean) { this._isMain = v; } public get isMain(): boolean { return this._isMain;} private _isMain: boolean;
    public set isReserving(v: boolean) { this._isReserving = v; } public get isReserving(): boolean { return this._isReserving;} private _isReserving: boolean;
    public set eucalyptusColor(v: boolean) { this._eucalyptusColor = v; } public get eucalyptusColor(): boolean { return this._eucalyptusColor;} private _eucalyptusColor: boolean;
    public set surfieGreen(v: boolean) { this._surfieGreen = v; } public get surfieGreen(): boolean { return this._surfieGreen;} private _surfieGreen: boolean;
    public set prairieSandColor(v: boolean) { this._prairieSandColor = v; } public get prairieSandColor(): boolean { return this._prairieSandColor;} private _prairieSandColor: boolean;
    public set shamrockColor(v: boolean) { this._shamrockColor = v; } public get shamrockColor(): boolean { return this._shamrockColor;} private _shamrockColor: boolean;
    public set lynchColor(v: boolean) { this._lynchColor = v; } public get lynchColor(): boolean { return this._lynchColor;} private _lynchColor: boolean;
    public set commonRedColor(v: boolean) { this._commonRedColor = v; } public get commonRedColor(): boolean { return this._commonRedColor;} private _commonRedColor: boolean;
    public set billNo(v: string) { this._billNo = v; } public get billNo(): string { return this._billNo;} private _billNo: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    
    public set receiptAmount(v: number) { this._receiptAmount = v; } public get receiptAmount(): number { return this._receiptAmount;} private _receiptAmount: number;
    public set orderAmount(v: number) { this._orderAmount = v; } public get orderAmount(): number { return this._orderAmount;} private _orderAmount: number;
    
    public set billType(v: number) { 
        this._billType = v; 
        switch(v){
            case 0:
                this.billTypeString = 'موجودی اولیه';
                this.isInitialBalance = true;
                this.isMain = true;
                this.isReserving = true;
                this.lynchColor = true;
                break;
            case 1:
                this.billTypeString = 'رسید';
                this.isReceipt = true;
                this.isMain = true;
                this.shamrockColor = true;
                break;
            case 2:
                this.billTypeString = 'حواله';
                this.isOrder = true;
                this.isMain = true;
                this.prairieSandColor = true;
                break;
            case 3:
                this.billTypeString = 'رسید رزرو';
                this.isReservingReceipt = true;
                this.isReserving = true;
                this.surfieGreen = true;
                break;
            case 4:
                this.billTypeString = 'حواله رزرو';
                this.isReservingOrder = true;
                this.isReserving = true;
                this.commonRedColor = true;
                break;
            case 5:
                this.billTypeString = 'موجودی نهایی';
                this.isFinalBalance = true;
                this.isMain = true;
                this.isReserving = true;
                this.lynchColor = true;
                break;
        }
    } 
    public get billType(): number { return this._billType;} private _billType: number;
    public set billTypeString(v: string) { this._billTypeString = v; } public get billTypeString(): string { return this._billTypeString;} private _billTypeString: string;
    public set isReceipt(v: boolean) { this._isReceipt = v; } public get isReceipt(): boolean { return this._isReceipt;} private _isReceipt: boolean;
    public set isOrder(v: boolean) { this._isOrder = v; } public get isOrder(): boolean { return this._isOrder;} private _isOrder: boolean;
    public set isReservingReceipt(v: boolean) { this._isReservingReceipt = v; } public get isReservingReceipt(): boolean { return this._isReservingReceipt;} private _isReservingReceipt: boolean;
    public set isReservingOrder(v: boolean) { this._isReservingOrder = v; } public get isReservingOrder(): boolean { return this._isReservingOrder;} private _isReservingOrder: boolean;
    public set isInitialBalance(v: boolean) { this._isInitialBalance = v; } public get isInitialBalance(): boolean { return this._isInitialBalance;} private _isInitialBalance: boolean;
    public set isFinalBalance(v: boolean) { this._isFinalBalance = v; } public get isFinalBalance(): boolean { return this._isFinalBalance;} private _isFinalBalance: boolean;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName;} private _partyName: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set amount(v: number) { 
        this._amount = v; 
        if(this.isOrder || this.isReservingOrder){
            this.orderAmount = this.amount;
        }
        if(this.isReceipt || this.isReservingReceipt){
            this.receiptAmount = this.amount;
        }
        if(this.isInitialBalance || this.isFinalBalance){
            this.orderAmount = this.amount;
            this.receiptAmount = this.amount;
        }
    } 
    public get amount(): number { return this._amount;} private _amount: number;
    public set warehouseBalance(v: number) { this._warehouseBalance = v; } public get warehouseBalance(): number { return this._warehouseBalance;} private _warehouseBalance: number;
    public set cumulativeBalance(v: number) { this._cumulativeBalance = v; } public get cumulativeBalance(): number { return this._cumulativeBalance;} private _cumulativeBalance: number;
    public set warehouseAvailableBalance(v: number) { this._warehouseAvailableBalance = v; } public get warehouseAvailableBalance(): number { return this._warehouseAvailableBalance;} private _warehouseAvailableBalance: number;
    public set cumulatieAvailableBalance(v: number) { this._cumulatieAvailableBalance = v; } public get cumulatieAvailableBalance(): number { return this._cumulatieAvailableBalance;} private _cumulatieAvailableBalance: number;
    public set billUsageParameter(v: string) { this._billUsageParameter = v; } public get billUsageParameter(): string { return this._billUsageParameter;} private _billUsageParameter: string;
    public set billUsageName(v: string) { this._billUsageName = v; } public get billUsageName(): string { return this._billUsageName;} private _billUsageName: string;
    public set allBillUsages(v: ObservableArray<BillUsage>) { this._allBillUsages = v; } public get allBillUsages(): ObservableArray<BillUsage> { return this._allBillUsages;} private _allBillUsages: ObservableArray<BillUsage>;
    public set user(v: string) { this._user = v; } public get user(): string { return this._user;} private _user: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description;} private _description: string;
    
}
export class BillUsage extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
}